import { createClient } from "@supabase/supabase-js";
export function createSupabaseClient(supabaseUrl, supabaseAnonKey, options) {
    return createClient(supabaseUrl, supabaseAnonKey, options);
}
